'use client'
import { useCallback, useState } from 'react'
import type { FC } from 'react'
import styles from './AddressInputContainer.module.scss'
import { useLocalisation } from '@/tools/i18n/client'
import { redirectToCityPage } from '@/tools/migration-helpers/execute-action'
import { ArrowForwardIcon, LocationMarkerIcon, TextInput } from '@/tools/ui'
import { CurrentLocationButton } from '@/tools/ui/components/hero-container/components/CurrentLocationButton'
import { AddressBookModal } from '@/user/address-book/ui/AddressBookModal'

export const AddressInputContainer: FC = () => {
  const { t } = useLocalisation()
  const [isOpenAddressBook, setIsOpenAddressBook] = useState(false)

  const handleOpenAddressBook = useCallback(() => setIsOpenAddressBook(true), [])
  const handleCloseAddressBook = useCallback(() => setIsOpenAddressBook(false), [])
  const handleAddressSelect = useCallback(async () => await redirectToCityPage(), [])

  const trailingAccessory = <ArrowForwardIcon outline />
  return (
    <>
      <div className={styles.inputContainer} id={'hero-container-input'}>
        <TextInput
          readOnly
          leadingAccessory={<LocationMarkerIcon outline />}
          placeholder={t('landing.address-picker')}
          trailingAccessory={trailingAccessory}
          onClick={handleOpenAddressBook}
        />
        <CurrentLocationButton />
      </div>
      <AddressBookModal
        isOpen={isOpenAddressBook}
        onClose={handleCloseAddressBook}
        onSelect={handleAddressSelect}
      />
    </>
  )
}
